import React, { useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import "./ListingStatistics.css"
import { IconButton, Typography } from "@material-ui/core";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';

const useStyles = makeStyles(theme => ({
  textColor: {
    color: theme.palette.primary.main
  },
  clicked: {
      backgroundColor: theme.palette.secondary.main,
      position: "relative",
      transition: "all .5s ease",
      WebkitTransition: "all .5s ease",
      MozTransition: "all .5s ease"
  }
}))

export default function ListingStatistics(props) {
    const dashboard = useSelector((state) => state.dashboard)
    const classes = useStyles()
    const [openInfo, setOpenInfo] = useState(false);
    const rea_daily = dashboard?.data?.statistics?.rea_stat?.daily
    const total_last = rea_daily?.length > 0 ? rea_daily[rea_daily.length -1].searchResultsPageImpression : 0

    const handleClick = () => {
      setOpenInfo(!openInfo)
    }

    return (
        <div className={`listing-stat ${openInfo ? classes.clicked : ""}`}>
                <div className="stat-general">
                    <IconButton onClick={handleClick} style={{position: "absolute", right: "0", top: "0", padding: "0" }}>
                        {openInfo ? <ClearOutlinedIcon fontSize="small" style={{fill:"white"}}/> : <InfoOutlinedIcon fontSize="small" style={{fill:"black"}}/>}
                    </IconButton>
                    {openInfo ? 
                      <div>
                        <Typography variant="subtitle2" style={{color: "white"}}>Total Exposure Views</Typography>
                        <Typography variant="subtitle1" style={{color: "white"}}>Where available, the combined total impressions of your property listing, across the relevant portals and websites.</Typography>
                      </div>
                      :
                      <div>
                        <Typography className={classes.textColor} variant="h3">
                          {dashboard?.data?.statistics?.total_property_exposure} 
                          <Typography className={classes.textColor} display={"inline"} variant="body1"> Total Exposure Views</Typography>
                        </Typography>
                        <Typography variant="body1">
                          Up by {total_last} today
                        </Typography>
                      </div>}
                </div>
        </div>
    );
}